import axios from "axios";

export const getUtentiApi = (filtro = '') => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/utente/${filtro}`);
}

export const getUtenteByIdApi = (idUsr) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/utente/${idUsr}`);
}

export const aggiornaUtenteApi = (idUsr, user) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/sost/utente/${idUsr}`, user);
}

export const aggiungiUtenteApi = (user) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/sost/utente/`, user);
}

export const deleteUtenteApi = (idUtente) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/sost/utente/${idUtente}`);
}